import { Identity } from '@sdbn/common';
export class BeginUmbrueckung {

  sourceTransport: Identity;
  sourceTransportStationId: Identity;
  targetTransport: Identity;
  targetTransportStationId: Identity;
  trailerNumberPlate: string;
  swapTrailerNumber: string;

}
